import React, { useCallback } from "react";
import { PaymentsContextProvider } from "./Context/PaymentsContext";
import { PaymentBatchesTable } from "./PaymentBatchesTable";
import { PaymentDetails } from "./PaymentDetails";
import type { PaymentRowItem } from "./PaymentBatchesTable/types";
import type { PaymentsListWorkflowProps } from "./types";

/**
 * This component contains the Payment Batches table and the Payment Batch slideout drawer.
 * The props selectedBatchId and onBatchSelected are used to control the slideout drawer.
 * The reason this lives outside the workflow is because of the routing.
 */
export const PaymentsListWorkflow: React.FC<PaymentsListWorkflowProps> = ({
  paymentsContext,
  selectedBatchId: batchId,
  onBatchSelected,
  onSlideoutClose,
}) => {
  const onPaymentBatchSelected = useCallback(
    (paymentRowItem?: PaymentRowItem): void => {
      onBatchSelected(paymentRowItem?.id);
    },
    [onBatchSelected],
  );

  return (
    <PaymentsContextProvider value={paymentsContext}>
      <PaymentBatchesTable onBatchSelected={onPaymentBatchSelected} />
      <PaymentDetails paymentBatchId={batchId} onClose={onSlideoutClose} />
    </PaymentsContextProvider>
  );
};

export default PaymentsListWorkflow;
